var map = {
	"./api_users_resource.js": 169,
	"./api_users_resource.js.coffee": 169,
	"./categories_resource.js": 170,
	"./categories_resource.js.coffee": 170,
	"./email_resource.js": 171,
	"./email_resource.js.coffee": 171,
	"./flickr_resource": 172,
	"./flickr_resource.coffee": 172,
	"./groups_resource.js": 173,
	"./groups_resource.js.coffee": 173,
	"./groups_series_resource.js": 174,
	"./groups_series_resource.js.coffee": 174,
	"./groups_sets_resource.js": 175,
	"./groups_sets_resource.js.coffee": 175,
	"./images_resource.js": 176,
	"./images_resource.js.coffee": 176,
	"./item_upload_resource.js": 177,
	"./item_upload_resource.js.coffee": 177,
	"./items_resource.js": 178,
	"./items_resource.js.coffee": 178,
	"./languages_resource.js": 179,
	"./languages_resource.js.coffee": 179,
	"./library_resource.js": 180,
	"./library_resource.js.coffee": 180,
	"./my-groups-resource.js": 181,
	"./my-groups-resource.js.coffee": 181,
	"./my_mailers_resource.js": 182,
	"./my_mailers_resource.js.coffee": 182,
	"./my_series_resource": 183,
	"./my_series_resource.coffee": 183,
	"./my_sets_resource": 184,
	"./my_sets_resource.coffee": 184,
	"./oauth2_clients_resource.js": 185,
	"./oauth2_clients_resource.js.coffee": 185,
	"./partner_user_roles_resource.js": 186,
	"./partner_user_roles_resource.js.coffee": 186,
	"./partner_users_resource.js": 187,
	"./partner_users_resource.js.coffee": 187,
	"./scorm_packages_resource.js": 188,
	"./scorm_packages_resource.js.coffee": 188,
	"./series_collaborators_resource.js": 189,
	"./series_collaborators_resource.js.coffee": 189,
	"./series_resource.js": 190,
	"./series_resource.js.coffee": 190,
	"./sessions_resource.js": 191,
	"./sessions_resource.js.coffee": 191,
	"./set_collaborators_resource.js": 192,
	"./set_collaborators_resource.js.coffee": 192,
	"./set_exports_resource.js": 193,
	"./set_exports_resource.js.coffee": 193,
	"./sets_resource.js": 194,
	"./sets_resource.js.coffee": 194,
	"./subscriptions_resource.js": 195,
	"./subscriptions_resource.js.coffee": 195,
	"./tag-type-resource.js": 196,
	"./tag-type-resource.js.coffee": 196,
	"./timezones_resource.js": 197,
	"./timezones_resource.js.coffee": 197,
	"./transliteration_distractors_resource.js": 198,
	"./transliteration_distractors_resource.js.coffee": 198,
	"./user_csv_uploads_resource.js": 199,
	"./user_csv_uploads_resource.js.coffee": 199,
	"./user_series_collaborators_resource.js": 200,
	"./user_series_collaborators_resource.js.coffee": 200,
	"./users_resource.js": 201,
	"./users_resource.js.coffee": 201,
	"./v3-course-users-resource.js": 202,
	"./v3-course-users-resource.js.coffee": 202,
	"./v3-courses-resource.js": 203,
	"./v3-courses-resource.js.coffee": 203,
	"./v3-my-milestones-resource.js": 204,
	"./v3-my-milestones-resource.js.coffee": 204,
	"./v3-my-study-items-resource.js": 205,
	"./v3-my-study-items-resource.js.coffee": 205,
	"./v3-series-items-resource.js": 206,
	"./v3-series-items-resource.js.coffee": 206,
	"./v3_set_clones_resource.js": 207,
	"./v3_set_clones_resource.js.coffee": 207,
	"./v3_set_items_resource.js": 208,
	"./v3_set_items_resource.js.coffee": 208,
	"./v4-recommended-sets-resource.js": 209,
	"./v4-recommended-sets-resource.js.coffee": 209
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 521;